import { getMessage } from '@tcc/i18n';
import { PlantingEvent as BySeasonPlantingEvent, PlantingEvents, PlantingProducts } from '../../types';
import { QueryPlantingEvent, SeedProductEvent } from './types/QueryPlantingEvent';
import { LOCALE_GROUPS, POPULATION_WEIGHT_UNITS } from '../../constants/units';
import { buildSeasonTagWithWildcards } from '../../utils/seasonUtils';
import { LegacyCropsMap } from './types/LegacyCropsMap';

function adaptSeedProducts(seedProductEvents: SeedProductEvent[]): PlantingProducts {
  return seedProductEvents.map(({seedProduct, plantedArea, firstPlantedDateTime}) => {
    const productId =  seedProduct?.id ? seedProduct.id : 'unknown';
    const productName = seedProduct?.name ? seedProduct.name : getMessage('legend.unknown');

    return {
      id: productId,
      name: productName,
      plantedArea: plantedArea.v,
      unit: plantedArea.u,
      date: firstPlantedDateTime,
    };
  });
}

function adaptPlantingEvent({
  averageSeedingRate,
  firstPlantedDateTime,
  plantedArea,
  seedProductEvents
}: QueryPlantingEvent): BySeasonPlantingEvent {
   const averageSeedingRateLocaleGroup = averageSeedingRate.u === POPULATION_WEIGHT_UNITS.PLANTING_ABBREVIATED
        ? LOCALE_GROUPS.POPULATION_WEIGHT
        : LOCALE_GROUPS.POPULATION

  return {
    date: firstPlantedDateTime,
    seedProducts: adaptSeedProducts(seedProductEvents),
    area: {
      q: plantedArea.v,
      u: plantedArea.u
    },
    population: {
      q: averageSeedingRate.v,
      u: averageSeedingRate.u,
      localeGroup: averageSeedingRateLocaleGroup
    }
  }
}

export function adaptUapiPlantingResponse(response: QueryPlantingEvent[], cropsMaps: LegacyCropsMap): PlantingEvents {
  const defaultResult: PlantingEvents = {
    events: {},
    plantingSeasons: [],
  };

  return response.reduce((accum, currentPlantingEvent) => {
    const { seasonYear, seasonName, crop} = currentPlantingEvent;

    const legacySeasonCode = buildSeasonTagWithWildcards({
      year: seasonYear,
      season: seasonName,
      cropCode: cropsMaps[crop.id]
    });

    if (!accum.events[legacySeasonCode]) {
      return {
        ...accum,
        events: {
          ...accum.events,
          [legacySeasonCode]: adaptPlantingEvent(currentPlantingEvent),
        },
        plantingSeasons: [
          ...accum.plantingSeasons,
          { season: legacySeasonCode }
        ]
      };
    }

    return accum;
  }, defaultResult);
}